/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Obligations_S42_Item_4Inputs */

const es_tyc_obligations_s42_item_4 = /** @type {(inputs: Tyc_Obligations_S42_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir credenciales de Fuentes Conectadas con terceros no autorizados.`)
};

const en_tyc_obligations_s42_item_4 = /** @type {(inputs: Tyc_Obligations_S42_Item_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Connected Sources credentials obtained through Nexata with unauthorized third parties.`)
};

/**
* | output |
* | --- |
* | "Share Connected Sources credentials obtained through Nexata with unauthorized third parties." |
*
* @param {Tyc_Obligations_S42_Item_4Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_obligations_s42_item_4 = /** @type {((inputs?: Tyc_Obligations_S42_Item_4Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Obligations_S42_Item_4Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_obligations_s42_item_4(inputs)
	return en_tyc_obligations_s42_item_4(inputs)
});
export { tyc_obligations_s42_item_4 as "tyc.obligations.s42_item_4" }